import { CancelablePromise, OpenAPI, request as __request } from '/src/api';
import { TUserId, User } from '/src/lib/models';
import type {
  TCreateUserRequest,
  TCreateUserResponse,
  TDeleteUserResponse,
  TGetUserResponse,
  TListUsersRequest,
  TListUsersResponse,
  TUpdateUserRequest,
  TUpdateUserResponse,
} from '/src/lib/types';

export class UserService {
  // TODO: how do we properly represent routes for `users.client.service.js` lines 5-13?

  /**
   * List Users
   * @returns User[]
   * @throws ApiError
   */
  public static async query(req?: TListUsersRequest): CancelablePromise<User[]> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/users',
      query: req,
    })) as TListUsersResponse;

    return res;
  }

  /**
   * Get User
   * @param id TUserId
   * @returns User
   * @throws ApiError
   */
  public static async get(id: TUserId): CancelablePromise<User> {
    const res = (await __request(OpenAPI, {
      method: 'GET',
      url: '/users/{id}',
      path: { id },
    })) as TGetUserResponse;

    return res;
  }

  /**
   * Create User
   * @param user User
   * @returns User
   * @throws ApiError
   */
  public static async create(req: TCreateUserRequest): CancelablePromise<User> {
    const res = (await __request(OpenAPI, {
      method: 'POST',
      url: '/api/users',
      body: req,
    })) as TCreateUserResponse;

    return res;
  }

  /**
   * Update User
   * @param user User
   * @returns User
   * @throws ApiError
   */
  public static async update(id: TUserId, req: TUpdateUserRequest): CancelablePromise<User> {
    const res = (await __request(OpenAPI, {
      method: 'PUT',
      url: '/users/{id}',
      path: { id },
      body: req,
    })) as TUpdateUserResponse;

    return res;
  }

  /**
   * Delete User
   * @param id TUserId
   * @returns User
   * @throws ApiError
   */
  public static async remove(id: TUserId): CancelablePromise<User> {
    const res = (await __request(OpenAPI, {
      method: 'DELETE',
      url: '/users/{id}',
      path: { id },
    })) as TDeleteUserResponse;

    return res;
  }
}
